import { render } from "./CaptureFooterComponent.vue?vue&type=template&id=7f57a603&scoped=true"
import script from "./CaptureFooterComponent.vue?vue&type=script&lang=js"
export * from "./CaptureFooterComponent.vue?vue&type=script&lang=js"

import "./CaptureFooterComponent.vue?vue&type=style&index=0&id=7f57a603&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f57a603"]])

export default __exports__